export default "/static/media/device-backgroundBlank.326c3145.png";